import { ListTodo } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useOrg } from "@/lib/states/session/hooks";
import { useStore } from "@/lib/states/store";
import { tasksSheetOpenSelector } from "@/lib/states/dialog/selectors";
import { trpc } from "@/lib/trpc/client";
import { toIsoDate } from "./taskMenus";

const TasksBell = () => {
  const org = useOrg();
  const openSheet = useStore(tasksSheetOpenSelector);
  const { data: assignedCount = 0 } = trpc.tasks.assignedCount.useQuery(
    { today: toIsoDate(new Date()) },
    { enabled: Boolean(org?.id) },
  );

  return (
    <Button
      variant="ghost"
      size="icon"
      className="relative h-8 w-8"
      onClick={() => openSheet()}
      data-analytics="tasks-bell"
    >
      <ListTodo className="h-4 w-4" />
      {assignedCount > 0 && (
        <span className="absolute -right-1 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-destructive px-1 text-xs font-semibold text-destructive-foreground">
          {assignedCount}
        </span>
      )}
      <span className="sr-only">View tasks</span>
    </Button>
  );
};

export default TasksBell;
